import { useContext } from 'react';
import { CreateUpdateContext } from '../../CreateUpdatesDialog.query';

import {
  Container,
  Text,
  Button,
  Row,
  Checkbox,
  Divider,
} from './RelationshipType.styles';

const RelationshipType = () => {
  const { relatesTo } = useContext(CreateUpdateContext);

  return (
    <Container>
      <Text>Relates to:</Text>

      <Button onClick={() => relatesTo.set('manufacturers')}>
        <Row>
          <Checkbox active={relatesTo.get() === 'manufacturers'} />
          <Text className="label">Manufacturer(s)</Text>
        </Row>
        <Text className="description">
          The update will be related: One or multiple manufacturers
        </Text>
        <Text className="small-description">
          (i.e. Mandated Security Update on Cisco Software)
        </Text>
      </Button>

      <Divider height="24px" />

      <Button onClick={() => relatesTo.set('products')}>
        <Row>
          <Checkbox active={relatesTo.get() === 'products'} />
          <Text className="label">Product(s)</Text>
        </Row>

        <Text className="description">
          The update will be related: One or multiple Products
        </Text>
        <Text className="small-description">
          (i.e. Mandated Security Update on Cisco Software)
        </Text>
      </Button>

      {/* <Divider height="24px" />

      <Button onClick={() => relatesTo.set('tags')}>
        <Row>
          <Checkbox active={relatesTo.get() === 'tags'} />
          <Text className="label">Tag(s)</Text>
        </Row>

        <Text className="description">
          The update will be related to all assets of one or multiple tags.
        </Text>
        <Text className="small-description">
          (i.e. Studio 3 maintenance shutdown)
        </Text>
      </Button> */}
    </Container>
  );
};

export { RelationshipType };
